import { styled } from "styled-components";

const ListDetails = styled.div`
    width: 100%;

    .header-list{
        width: 100%;
        display: flex;

        padding: 10px 10px;

        background: #fafafa;
        border-bottom: 1px solid #f0f0f0;

    
        .item-header{
            padding: 0px 10px;
            width: 350px;
            text-align: start;

            border-right: 1px solid #f0f0f0;
        }

        .item-header:nth-last-child(-n+2){
            border: none;
        }

        .item-header:last-child{
            border-left: 1px solid #f0f0f0;
            border-right: none;
        }

       
    }

    .list-content{
        padding: 10px 10px;
        width: 100%;

        display: flex;
        flex-direction: column;
    }

    .data-row{
        display: flex;
        border-bottom: 1px solid #f0f0f0;
        padding: 10px 0px;
    

        .item-list{
            width: 350px;
            padding: 0px 10px;

            
        }
    }
`

export default ListDetails;